import api from '../../../../api/client';

export const MONTH_OPTIONS = [
  { value: 'All', label: 'All Months' },
  { value: 'Jan', label: 'January' },
  { value: 'Feb', label: 'February' },
  { value: 'Mar', label: 'March' },
  { value: 'Apr', label: 'April' },
  { value: 'May', label: 'May' },
  { value: 'Jun', label: 'June' },
  { value: 'Jul', label: 'July' },
  { value: 'Aug', label: 'August' },
  { value: 'Sep', label: 'September' },
  { value: 'Oct', label: 'October' },
  { value: 'Nov', label: 'November' },
  { value: 'Dec', label: 'December' },
];

export const YEAR_OPTIONS = [
  { value: 'All', label: 'All Years' },
  { value: '2026', label: '2026' },
  { value: '2025', label: '2025' },
  { value: '2024', label: '2024' },
];

const MONTH_MAP = {
  Jan: 1, Feb: 2, Mar: 3, Apr: 4, May: 5, Jun: 6,
  Jul: 7, Aug: 8, Sep: 9, Oct: 10, Nov: 11, Dec: 12,
};

export const payslipApi = {
  getList: async (monthStr = 'Aug', yearStr = '2026') => {
    try {
      const monthNum = MONTH_MAP[monthStr] || 8;
      const yearNum = Number(yearStr) || 2026;
      const response = await api.get('/self-service/payslip/', {
        params: { month: monthNum, year: yearNum },
      });
      const data = response.data;
      if (!data) return { data: [] };

      const records = [];
      let idCounter = 1;

      (data.Earnings || []).forEach((e) => {
        records.push({
          id: idCounter++,
          month: monthStr,
          year: String(yearNum),
          monthYear: `${monthStr} ${yearNum}`,
          payHead: e.Name || e.Alias || 'Basic Pay',
          payHeadType: 'Earnings',
          drCr: 'Cr',
          amount: Number(e.Amount || 0),
          formattedAmount: `₹${Number(e.Amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
          remarks: e.PayHeadType || 'Earnings component',
        });
      });

      (data.Deductions || []).forEach((d) => {
        records.push({
          id: idCounter++,
          month: monthStr,
          year: String(yearNum),
          monthYear: `${monthStr} ${yearNum}`,
          payHead: d.Name || d.Alias || 'Deduction',
          payHeadType: 'Deductions',
          drCr: 'Dr',
          amount: Number(d.Amount || 0),
          formattedAmount: `₹${Number(d.Amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`,
          remarks: d.PayHeadType || 'Deduction component',
        });
      });

      return { data: records, raw: data };
    } catch (err) {
      console.warn('Failed to fetch payslip from backend:', err);
      return { data: [] };
    }
  },

  getMonthlyPayslip: async (month, year) => {
    try {
      const response = await api.get('/self-service/payslip/', {
        params: { month, year },
      });
      return response.data;
    } catch (err) {
      console.warn('Failed to get monthly payslip details:', err);
      return null;
    }
  },

  getHistory: async () => {
    try {
      const response = await api.get('/self-service/payslip/history');
      return response.data.items || [];
    } catch (err) {
      console.warn('Failed to get payslip history:', err);
      return [];
    }
  },
};
